export const startEditingCommunity = async (cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/startEditing", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ cpUrlId }, null, 2),
    });

    return await result.json();
};

export const readyForReview = async (cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/readyForReview", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ cpUrlId }, null, 2),
    });

    return await result.json();
};

export const publishCommunity = async (cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/publish", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ cpUrlId }, null, 2),
    });

    return await result.json();
};

export const aiInit = async (cpUrlId, communityWebsite, email, communityId, token) => {
    const result = await fetch("/api/community-portal/community/aiInit", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ cpUrlId, communityWebsite, email, communityId }, null, 2),
    });

    return await result.json();
};

/**
 * Here the nameId could be the nameId of the claimed community, so we need to copy it
 * @param {*} name
 * @param {*} nameId
 * @param {*} token
 * @returns
 */
export const createCommunity = async (
    name,
    nameId,
    numberOfUnits,
    licenseNumber,
    licenseNumber2,
    licenseNumber3,
    contactName,
    token
) => {
    const result = await fetch("/api/community-portal/community/create", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify(
            {
                name,
                nameId,
                numberOfUnits,
                licenseNumber,
                licenseNumber2,
                licenseNumber3,
                contactName,
            },
            null,
            2
        ),
    });

    return await result.json();
};

export const createCommunityPortalUser = async (uid, email, name, companyId) => {
    const result = await fetch(
        "/api/community-portal/community/createCommunityPortalUser",
        {
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ uid, name, email, companyId }, null, 2),
        }
    );

    return await result.json();
};

export const updateCommunity = async (values, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/update", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const updateCommunityName = async (values, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/name/update", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const createAddress = async (values, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/address/create", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const updateAddress = async (values, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/address/update", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const createPhone = async (values, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/phone/create", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const updatePhone = async (values, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/phone/update", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const addContact = async (values, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/contact/create", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const updateContact = async (values, cpUrlId, communityContactId, token) => {
    const result = await fetch("/api/community-portal/community/contact/update", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId, communityContactId }, null, 2),
    });
};

export const deleteContact = async (communityContactId, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/contact/delete", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ communityContactId, cpUrlId }, null, 2),
    });
};

export const addTemplate = async (values, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/template/create", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const updateTemplate = async (values, templateId, token) => {
    const result = await fetch("/api/community-portal/community/template/update", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, _id: templateId }, null, 2),
    });
};

export const deleteTemplate = async (templateId, token) => {
    const result = await fetch("/api/community-portal/community/template/delete", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ _id: templateId }, null, 2),
    });
};

export const addUnit = async (values, cpUrlId, token) => {
    const result = await fetch("/api/community-portal/community/unit/create", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const updateUnit = async (values, unitId, token) => {
    const result = await fetch("/api/community-portal/community/unit/update", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, _id: unitId }, null, 2),
    });
};

export const deleteUnit = async (unitId, token) => {
    const result = await fetch("/api/community-portal/community/unit/delete", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ _id: unitId }, null, 2),
    });
};

export const addImage = async (values, cpUrlId, token) => {
    console.log("addImage", values, cpUrlId);
    const result = await fetch("/api/community-portal/community/image/create", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, cpUrlId }, null, 2),
    });
};

export const updateImage = async (values, imageId, token) => {
    const result = await fetch("/api/community-portal/community/image/update", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, _id: imageId }, null, 2),
    });
};

export const deleteImage = async (imageId, token) => {
    const result = await fetch("/api/community-portal/community/image/delete", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ _id: imageId }, null, 2),
    });
};

export const addTemplateImage = async (values, templateId, token) => {
    const result = await fetch("/api/community-portal/community/template/image/create", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, templateId }, null, 2),
    });
};

export const updateTemplateImage = async (values, imageId, token) => {
    const result = await fetch("/api/community-portal/community/template/image/update", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ ...values, _id: imageId }, null, 2),
    });
};

export const deleteTemplateImage = async (imageId, token) => {
    const result = await fetch("/api/community-portal/community/template/image/delete", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            token,
        },
        body: JSON.stringify({ _id: imageId }, null, 2),
    });
};
